import styled from "@emotion/styled";

export const UserTypeToggleRoot = styled.button`
  padding: 0 0.5rem;
  color: var(--mb-color-filter);
  cursor: pointer;
  vertical-align: middle;
`;
